import defaults from 'store/plugins/defaults';
import engine from 'store/src/store-engine';
import storeCookieStorage from 'store/storages/cookieStorage';
import storeLocalStorage from 'store/storages/localStorage';
import storeSessionStorage from 'store/storages/sessionStorage';
import storeMemoryStorage from 'store/storages/memoryStorage';
export var prefix = function prefix() {
  return {
    set: function set(superFn, key, value) {
      return superFn("".concat(process.env.CACHE_PREFIX).concat(key), value);
    },
    get: function get(superFn, key) {
      return superFn("".concat(process.env.CACHE_PREFIX).concat(key));
    },
    remove: function remove(superFn, key) {
      return superFn("".concat(process.env.CACHE_PREFIX).concat(key));
    }
  };
};
export var storage = engine.createStore([storeSessionStorage, storeLocalStorage, storeCookieStorage, storeMemoryStorage], [defaults, prefix]);
export var localStorage = engine.createStore([storeLocalStorage, storeSessionStorage, storeMemoryStorage], [defaults, prefix]);
export var allCacheEntries = function allCacheEntries() {
  var entries = {
    localStorage: {},
    sessionStorage: {}
  };
  localStorage.each(function (value, key) {
    if (key.indexOf(process.env.CACHE_PREFIX) !== -1) {
      entries.localStorage[key] = value;
    }
  });
  storage.each(function (value, key) {
    if (key.indexOf(process.env.CACHE_PREFIX) !== -1) {
      entries.sessionStorage[key] = value;
    }
  });
  return entries;
};